// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".report-page table tr.my-report td {\n  font-weight: bold;\n  color: #adadad;\n}\n", "",{"version":3,"sources":["webpack://src/views/Report/style.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":[".report-page table tr.my-report td {\n  font-weight: bold;\n  color: #adadad;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
